/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AnyAutoTestStepAsJSON } from './AnyAutoTestStepAsJSON';
const AnyRedactedAutoTestStepAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['redacted', /* #__PURE__ */ parsers.exactly(true)],
    [
        'type',
        /* #__PURE__ */ parsers.exactly('check_points', 'code_quality', 'custom_output', 'io_test', 'junit_test', 'run_program'),
    ],
    ['data', codec.unknown],
]), AnyAutoTestStepAsJSON);
export class AnyRedactedAutoTestStepAsJSON extends AnyAutoTestStepAsJSON {
    static decode(input) {
        return AnyRedactedAutoTestStepAsJSONParser.decode(input).map(res => new AnyRedactedAutoTestStepAsJSON(res));
    }
    static unsafeDecode(input) {
        return AnyRedactedAutoTestStepAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AnyRedactedAutoTestStepAsJSONParser.encode(data);
    }
    static schema() {
        return AnyRedactedAutoTestStepAsJSONParser.schema();
    }
}
